import { createContext, useContext, useState } from "react";

const ReserveContext = createContext(null);

export const useReserve = () => useContext(ReserveContext);

export function ReserveProvider({ children }) {
    const [product, setProduct] = useState(null);
    const open = (p) => setProduct(p);
    const close = () => setProduct(null);
    return (
        <ReserveContext.Provider value={{ product, open, close }}>
            {children}
        </ReserveContext.Provider>
    );
}
